import { PipeTransform } from '@angular/core';
var PrefixPipe = /** @class */ (function () {
    function PrefixPipe() {
    }
    PrefixPipe.prototype.transform = function (text, prefix) {
        return this.setFormat(text, prefix);
    };
    PrefixPipe.prototype.setFormat = function (text, prefix) {
        if (!text) {
            return prefix;
        }
        return prefix + text.replace(/\s/g, '').replace(/101-/g, '');
    };
    return PrefixPipe;
}());
export { PrefixPipe };
